import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Input from "../components/Input";
import MatchSpecificationOutput from "../components/MatchSpecificationOutput";

const MatchSpecification = () => {
    const [result, setResult] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleUpdateResult = (data: any) => {
        setResult(data);        
    };

    return (
        <div>
            <Container style={{ marginTop: 100 }}>
                <Row className="mb-5">
                    <Col
                        cols="6"
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 10,
                        }}
                    >
                        {/* Go back btn */}
                        <a
                            type="button"
                            className="btn btn-outline-black btn-md mx-1"
                            href={`/`}
                        >
                            <i className="bi bi-chevron-left"></i>
                        </a>
                        <h5 className="h5">Match Specification</h5>
                    </Col>
                </Row>

                {/* Specification input component */}
                <Input
                    handleUpdateResult={handleUpdateResult}
                    loading={loading}
                    setLoading={setLoading}
                />

                {/* Specification output component */}
                <MatchSpecificationOutput result={result} loading={loading} vehicleId="" readOnly />
            </Container>
        </div>
    );
};

export default MatchSpecification;
